/**
 * Handle lazy loading.
 *
 * Implementation:
 * 
 * Manual lazy loading:
 * Standard images & source should utilize native "loading" attribute ('lazy' or 'eager').
 * Images or sources that require manual lazy loading can use the "data-src" attribute with a 'lazyload' class.
 * 
 * Preloading lazy images:
 * Images with a 'lazypreload' class will be lazy preloaded.
 * 
 * Iframe lazy loading:
 * Iframes should use the native 'loading' attribute ('lazy'), 'data-src' attribute, and a 'lazyload' class.
 * Iframe lazy loading has partial browser support, we provide a progressive enhancement below.
 *
 * Ex:
 * <iframe
 * 	class="lazyload"
 * 	loading="lazy"
 * 	data-src="//www.youtube.com/embed/ZfV-aYdU4uE">
 * </iframe>
 */

/**
 * Determine if lazysizes library is required.
 */
let lazyReq = false;

/**
 * Default to native lazy loading if supported.
 *
 * @link https://web.dev/iframe-lazy-loading/
 */
const iframes = document.querySelectorAll('iframe[loading="lazy"]');
if (iframes.length) {
	if ('loading' in HTMLIFrameElement.prototype) {
		iframes.forEach(iframe => {
			if (iframe.dataset.src) {
				iframe.src = iframe.dataset.src;
			}
		});
	} else {
		lazyReq = true;
	}
}

/**
 * Support manualimage lazy loading and preloading.
 */
const lazyImg = document.querySelectorAll('img.lazyload, source.lazyload, img.lazypreload, source.lazypreload');
if (lazyImg.length) {
	lazyReq = true;
}

/**
 * Load lazysizes library if needed.
 */
if (lazyReq) {
	const script = document.createElement('script');
	script.src =
		'https://cdnjs.cloudflare.com/ajax/libs/lazysizes/5.2.2/lazysizes.min.js';
	document.body.appendChild(script);

	// Control lazyload transition.
	const style = document.createElement('style');
	style.innerHTML = `
		.lazyload,
		.lazypreload {
			opacity: 0;
			transition: opacity 0.3s;
		}
		.lazyloaded,
		.lazypreload.lazyloaded {
			opacity: 1;
		}
	`;
	document.querySelector('head').appendChild(style);
}
